// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"6931":"route-mantenimiento","9965":"route-dashboard"}[chunkId] || chunkId) + "." + {"3870":"7e068375","6931":"885806d2","9965":"23712ffd"}[chunkId] + ".chunk.css";
};